import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetRidehailsQueryVariables = Types.Exact<{
  customer_id?: Types.InputMaybe<Types.Scalars['bigint']['input']>;
  from_date?: Types.InputMaybe<Types.Scalars['timestamptz']['input']>;
  to_date?: Types.InputMaybe<Types.Scalars['timestamptz']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetRidehailsQuery = { __typename?: 'query_root', moves: Array<{ __typename?: 'moves', id: number, parent_move_id?: number | null, reference_num?: string | null, vehicle_vin?: string | null, vehicle_stock?: string | null, vehicle_year?: string | null, vehicle_make?: string | null, vehicle_model?: string | null, vehicle_color?: string | null, pickup_time?: string | null, status?: string | null, cancel_status?: string | null, cancel_reason?: string | null, consumer_type?: string | null, consumer_name?: string | null, consumer_phone?: string | null, consumer_pickup?: boolean | null, customer?: { __typename?: 'customers', id: number, name?: string | null } | null, lane?: { __typename?: 'lanes', id: number, description?: string | null, distance_miles?: number | null, pickup: { __typename?: 'locations', id: number, name?: string | null, address?: string | null }, delivery: { __typename?: 'locations', id: number, name?: string | null, address?: string | null } } | null, driver?: { __typename?: 'drivers', id: number, user?: { __typename?: 'users', id: number, display_name: string, avatar_url?: string | null } | null } | null, parentMove?: { __typename?: 'moves', consumer_name?: string | null, reference_num?: string | null, vehicle_vin?: string | null, driver_status?: string | null } | null, ridehails: Array<{ __typename?: 'ridehails', id: number, driver_name?: string | null, provider?: string | null, status?: string | null, external_id?: string | null, pickup_address?: string | null, dropoff_address?: string | null, pickup_at?: string | null, dropoff_at?: string | null, pickup_lat: number, pickup_lng: number, dropoff_lat: number, dropoff_lng: number, estimated_price?: number | null, actual_price?: number | null, created_at: string, updated_at: string }> }> };


export const GetRidehailsDocument = gql`
    query GetRidehails($customer_id: bigint, $from_date: timestamptz, $to_date: timestamptz, $limit: Int) {
  moves(
    where: {_and: [{customer_id: {_eq: $customer_id}}, {move_type: {_eq: "ride"}}, {driver_id: {_is_null: false}}, {pickup_time: {_gte: $from_date}}, {pickup_time: {_lte: $to_date}}, {active: {_eq: 1}}]}
    order_by: {pickup_time: desc}
    limit: $limit
  ) {
    id
    parent_move_id
    reference_num
    vehicle_vin
    vehicle_stock
    vehicle_year
    vehicle_make
    vehicle_model
    vehicle_color
    pickup_time
    status
    cancel_status
    cancel_reason
    consumer_type
    consumer_name
    consumer_phone
    consumer_pickup
    customer {
      id
      name
    }
    lane {
      id
      description
      pickup {
        id
        name
        address
      }
      delivery {
        id
        name
        address
      }
      distance_miles
    }
    driver {
      id
      user {
        id
        display_name
        avatar_url
      }
    }
    parentMove {
      consumer_name
      reference_num
      vehicle_vin
      driver_status
    }
    ridehails(order_by: {created_at: desc}, limit: 1) {
      id
      driver_name
      provider
      status
      external_id
      pickup_address
      dropoff_address
      pickup_at
      dropoff_at
      pickup_lat
      pickup_lng
      dropoff_lat
      dropoff_lng
      estimated_price
      actual_price
      created_at
      updated_at
    }
  }
}
    `;

/**
 * __useGetRidehailsQuery__
 *
 * To run a query within a React component, call `useGetRidehailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRidehailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRidehailsQuery({
 *   variables: {
 *      customer_id: // value for 'customer_id'
 *      from_date: // value for 'from_date'
 *      to_date: // value for 'to_date'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetRidehailsQuery(baseOptions?: Apollo.QueryHookOptions<GetRidehailsQuery, GetRidehailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRidehailsQuery, GetRidehailsQueryVariables>(GetRidehailsDocument, options);
      }
export function useGetRidehailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRidehailsQuery, GetRidehailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRidehailsQuery, GetRidehailsQueryVariables>(GetRidehailsDocument, options);
        }
// @ts-ignore
export function useGetRidehailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRidehailsQuery, GetRidehailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRidehailsQuery, GetRidehailsQueryVariables>;
export function useGetRidehailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRidehailsQuery, GetRidehailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRidehailsQuery | undefined, GetRidehailsQueryVariables>;
export function useGetRidehailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRidehailsQuery, GetRidehailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRidehailsQuery, GetRidehailsQueryVariables>(GetRidehailsDocument, options);
        }
export type GetRidehailsQueryHookResult = ReturnType<typeof useGetRidehailsQuery>;
export type GetRidehailsLazyQueryHookResult = ReturnType<typeof useGetRidehailsLazyQuery>;
export type GetRidehailsSuspenseQueryHookResult = ReturnType<typeof useGetRidehailsSuspenseQuery>;
export type GetRidehailsQueryResult = Apollo.QueryResult<GetRidehailsQuery, GetRidehailsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/ridehails/queries/getRidehails.query.gql}
 */
export async function getRidehails(
  variables: GetRidehailsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetRidehailsQuery['moves']>
export async function getRidehails(
  variables: GetRidehailsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetRidehailsQuery>
export async function getRidehails(
  variables: GetRidehailsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetRidehailsQuery['moves'] | GetRidehailsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetRidehailsQuery>(
    GetRidehailsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.moves
}